exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-add-blockout-day-button[data-v-ff1f3cf4],\n.custom-add-blockout-day-button[data-v-ff1f3cf4]:hover {\n  margin-left: 0;\n  background-color: #5f6771 !important;\n  margin-top: 10px;\n}\n.date-range-columns[data-v-ff1f3cf4] {\n  width: 175px;\n  min-width: 175px;\n  max-width: 175px;\n}\n.blockout-day-name-column[data-v-ff1f3cf4] {\n  width: 300px;\n  min-width: 300px;\n  max-width: 300px;\n}\n.blockout-day-table .md-table-row:nth-child(n + 3) > td[data-v-ff1f3cf4] {\n  border-top: 0 !important;\n}\n", ""]);

// exports
